'use client';
import { Controller, useFormContext } from 'react-hook-form';
import { CatRadioField } from '@blocks-react/components/RadioField';
import { RequestServiceContactRadioInputProps } from '../types';
import { v4 as uuid } from 'uuid';

export const RequestServiceContactRadioInput = ({
  name,
  children,
  value,
  classname
}: RequestServiceContactRadioInputProps) => {
  const { control, getValues, setValue } = useFormContext();
  const onBlChange = (): void => {
    setValue(name, value);
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={value}
      key={`${value}-${uuid()}`}
      render={() => (
        <CatRadioField
          name={name}
          checked={getValues(name) === value}
          onBlRadioChange={onBlChange}
          className={classname}
          data-cs-mask
        >
          {children}
        </CatRadioField>
      )}
    />
  );
};
